import server from "@/api/server";

async function getInviteData(id) {
  const res = await server.post("/agent/ext/invitation/confirm", {id: id});
  return res;
}

export {getInviteData};
